import { useTracking } from '@vp/react-tracking';
import React, { HTMLProps, PropsWithChildren, useState } from 'react';
import { Button, Link } from '@vp/swan';
import { __, __product, __vistaRoute, getCurrentCulture } from '@99designs/i18n';
import DesignServicesModal from '../components/DesignServicesModal';
import { useIsMdsCtaEnabled } from '../components/RegionLockedConfiguration';

export const StartNewProjectButton = () => {
    const currentCulture = getCurrentCulture();
    const isMdsCtaEnabled = useIsMdsCtaEnabled(currentCulture);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { tracking } = useTracking();

    const newProjectModal = isMdsCtaEnabled ? (
        <DesignServicesModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    ) : null;

    return (
        <>
            {newProjectModal}
            <Button
                skin="secondary"
                render={(props: PropsWithChildren<HTMLProps<HTMLElement>>) => (
                    <Link
                        to={
                            isMdsCtaEnabled
                                ? undefined
                                : `${__vistaRoute(
                                      '/design/briefs/create/care-design'
                                  )}?mpvId=${__product('mpv-id-business-card')}`
                        }
                        className={props.className}
                        onClick={() => {
                            if (isMdsCtaEnabled) {
                                setIsModalOpen(true);
                                tracking.track('Fly-Out Viewed', {
                                    action: 'Fly-Out Viewed',
                                    category: 'Fly-Out',
                                    label: 'My Design Services:Fly-Out',
                                    pageSection: 'Design Services',
                                    pageStage: 'My Account',
                                    pageName: 'Design Services:Dashboard',
                                });
                            }
                        }}
                        style={{ zIndex: 1 }}
                    >
                        {props.children}
                    </Link>
                )}
            >
                {__('Start a new project')}
            </Button>
        </>
    );
};
